"use client";
import { RecentLeaderProvider } from "./context";
import RecentTable from "@/components/client/DetailRecentTable";
import OddStatistic from "@/components/client/OddStatistic";
import CollapsiblePanel from "@/components/client/CollapsiblePanel";
import ICON_ARROW_UP_LEAGUES from "@/public/arrow_up_white_leagues.svg";
import ICON_ARROW_DOWN_LEAGUES from "@/public/arrow_down_white_leagues.svg";
import GoalStatistic from "@/components/client/GoalStatistic";
const IMAGE_ARROW_UP_LEAGUES = ICON_ARROW_UP_LEAGUES.src;
const IMAGE_ARROW_DOWN_LEAGUES = ICON_ARROW_DOWN_LEAGUES.src;

const RecentLeaderBoardContainer = ({ leagueId, home, away, formStats, goalStats, oddStats }) => {
  return (
    <RecentLeaderProvider
      initialHome={home}
      initialAway={away}
      initialFormStats={formStats}
      leagueId={leagueId}
    >
      <CollapsiblePanel
        title="Thành tích gần đây"
        initOpen={true}
        iconUp={IMAGE_ARROW_UP_LEAGUES}
        iconDown={IMAGE_ARROW_DOWN_LEAGUES}
      >
        <RecentTable />
        <OddStatistic oddStats={oddStats} />
        <GoalStatistic goalStats={goalStats} />
      </CollapsiblePanel>
    </RecentLeaderProvider>
  );
};

export default RecentLeaderBoardContainer;
